// extracted by mini-css-extract-plugin
module.exports = {"footer":"RemoveSectionSaveConfirmationModal_footer__1WVGC"};